import { Provider } from '@angular/core';
import { SPV, REGISTRY_LOOKUP, ONBOARDING_APPLICATION, ONBOARDING_HISTORY, KYC_WORKSPACE, FLOW_MONITOR, KO_CONFIG, BACKEND_MOCKS, RISK_RATING, LENDER_RISK_PROFILING, SIDE_TRACK_TRIGGERS, SANCTIONS_RESCREEN, KYC_PROSPECTS, UW_PROSPECTS, TASKS, MASTER_ADMIN_DASHBOARD, FLOW_CONTROL, MASTER_ADMIN_SETTINGS, MASTER_ADMIN_AUDIT, OVERRIDE_LOG, MASTER_ADMIN_USER_MGMT, LENDER_CONTRACT_SIGNING, ED_CONTRACT_SIGNING, ED_DISCOUNT_CONFIG, ED_PROSPECT, SME_CONTRACT_SIGNING, APPLICANT_MODIFICATION, SME_SESSION, SME_PERMISSIONS, ROLE_MATRIX, SCA, MY_AUDIT, MY_NOTIFICATIONS, SME_DASHBOARD_KPI, SME_PROFILE, REPRESENTATIVES, SME_DOCUMENTS, SME_CONSENTS, SME_PAYMENT_ACCOUNTS, SME_PAYMENTS, SME_PAYMENTS_DRAFTS, SME_TRANSACTIONS, SME_RECURRING, INTEGRATION_FAILURES, CARD, FINANCING_REQUEST, AUCTIONS, DEALS, LOANS, REPAYMENTS, MODIFICATIONS, INSURANCE, COLLECTIONS, LENDER_ACCOUNT, FINANCING_FLOW_MONITOR, BUSINESS_CARD, OFFICER_PREFERENCES, RATING_SCALE, REJECTION_CODES, UW_SERVICING, SLA_THRESHOLDS } from '../tokens';
// EM-1679 — the BRS Chapter-4 Master-Admin configuration surfaces (product catalogue, scoring weights,
// auction best-offer criteria, process timers) + the SME-facing catalogue read. REST-only (Rules 07/10).
import { CHAPTER4_CONFIG } from '../tokens/chapter4-config.token';
import { Chapter4ConfigRestService } from '../services/chapter4-config.service';
import { GRACE_CONFIG } from '../tokens/grace-config.token';
import { GraceConfigService } from '../services/grace-config.service';
import { GRACE_ACCOUNTS } from '../tokens/grace-accounts.token';
import { GraceAccountsService } from '../services/grace-accounts.service';
import { ESCALATION_ANALYTICS } from '../tokens/escalation-analytics.token';
import { EscalationAnalyticsRestService } from '../services/escalation-analytics-rest.service';
import { SLA_ESCALATIONS } from '../tokens/sla-escalations.token';
import { SlaEscalationsRestService } from '../services/sla-escalations-rest.service';
import { ESCALATION_SCOPE } from '../tokens/escalation-scope.token';
import { EscalationScopeRestService } from '../services/escalation-scope-rest.service';
import { TASK_REDISTRIBUTION } from '../tokens/task-redistribution.token';
import { TaskRedistributionRestService } from '../services/task-redistribution-rest.service';
import { LENDER_IDENTITY } from '../tokens/lender-identity.token';
import { LENDER_CHANNELS_API } from '../tokens/lender-channels.token';
import { LenderChannelsRestService } from '../services/lender-channels.service';
import { LenderIdentityRestService } from '../services/lender-identity.service';
import { LENDER_DASHBOARD } from '../tokens/lender-dashboard.token';
import { LenderDashboardRestService } from '../services/lender-dashboard.service';
import { LENDER_RISK_RULES } from '../tokens/lender-risk-rules.token';
import { KO_ADJUSTMENTS_ADMIN } from '../tokens/ko-adjustments.token';
import { KoAdjustmentsAdminRestService } from '../services/ko-adjustments.service';
import { LenderRiskRulesRestService } from '../services/lender-risk-rules.service';
import { LENDER_PRICING } from '../tokens/lender-pricing.token';
import { LenderPricingRestService } from '../services/lender-pricing.service';
import { LENDER_EXPOSURE } from '../tokens/lender-exposure.token';
import { LenderExposureRestService } from '../services/lender-exposure.service';
import { LENDER_OFFERS } from '../tokens/lender-offers.token';
import { LenderOffersRestService } from '../services/lender-offers.service';
import { LENDER_PORTFOLIO } from '../tokens/lender-portfolio.token';
import { LenderPortfolioRestService } from '../services/lender-portfolio.service';
import { LENDER_OPPORTUNITIES } from '../tokens/lender-opportunities.token';
import { LenderOpportunitiesRestService } from '../services/lender-opportunities.service';
import { LENDER_PROSPECTS } from '../tokens/lender-prospects.token';
import { LenderProspectsRestService } from '../services/lender-prospects.service';
import { LENDER_BLACKLIST } from '../tokens/lender-blacklist.token';
import { LenderBlacklistRestService } from '../services/lender-blacklist.service';
import { LENDER_PREAPPROVED_DEBTORS } from '../tokens/lender-preapproved-debtors.token';
import { LenderPreApprovedDebtorsRestService } from '../services/lender-preapproved-debtors.service';
import { DEBTOR_DIRECTORY } from '../tokens/debtor-directory.token';
import { QUESTIONNAIRE } from '../tokens/questionnaire.token';
import { DebtorDirectoryRestService } from '../services/debtor-directory.service';
import { QuestionnaireRestService } from '../services/questionnaire.service';
import { LENDER_REPAYMENTS_API } from '../tokens/lender-repayments.token';
import { LenderRepaymentsRestService } from '../services/lender-repayments.service';
import { LENDER_COLLECTIONS_API } from '../tokens/lender-collections.token';
import { LenderCollectionsRestService } from '../services/lender-collections.service';
import { LENDER_INSURANCE_API } from '../tokens/lender-insurance.token';
import { LenderInsuranceRestService } from '../services/lender-insurance.service';
import { LENDER_REPORTS_API } from '../tokens/lender-reports.token';
import { LenderReportsRestService } from '../services/lender-reports.service';
import { RM_ONBOARDING } from '../tokens/rm-onboarding.token';
import { RmOnboardingRestService } from '../services/rm-onboarding.service';
import { RM_BLACKLIST_REPORT } from '../tokens/rm-blacklist-report.token';
import { RmBlacklistReportRestService } from '../services/rm-blacklist-report.service';
import { FinancingFlowMonitorRestService } from '../services/financing-flow-monitor.service';
import { AuctionsRestService } from '../services/auctions.service';
import { DealsRestService } from '../services/deals.service';
import { LoansRestService } from '../services/loans.service';
import { RepaymentsRestService } from '../services/repayments.service';
import { ModificationsRestService } from '../services/modifications.service';
import { InsuranceRestService } from '../services/insurance.service';
import { CollectionsRestService } from '../services/collections.service';
import { LenderAccountRestService } from '../services/lender-account.service';
import { BusinessCardService } from '../services/business-card.service';
import { IntegrationFailuresRestService } from '../services/integration-failures.service';
import { CardRestService } from '../services/card.service';
import { FinancingRequestRestService } from '../services/financing-request.service';
import { SpvInvoicesRestService } from '../services/spv-invoices.service';
import { SmeProfileRestService } from '../services/sme-profile.service';
import { RepresentativesRestService } from '../services/representatives.service';
import { SmeDocumentsRestService } from '../services/sme-documents.service';
import { SmeConsentsRestService } from '../services/sme-consents.service';
import { SmeSessionRestService } from '../services/sme-session.service';
import { SmePaymentAccountsRestService } from '../services/sme-payment-accounts.service';
import { SmePaymentsRestService } from '../services/sme-payments.service';
import { SmePaymentsDraftsRestService } from '../services/sme-payments-drafts.service';
import { SmeTransactionsRestService } from '../services/sme-transactions.service';
import { SmeRecurringRestService } from '../services/sme-recurring.service';
import { SmePermissionsService } from '../services/sme-permissions.service';
import { RoleMatrixService } from '../services/role-matrix.service';
import { ScaRestService } from '../services/sca.service';
import { MyAuditRestService } from '../services/my-audit.service';
import { MyNotificationRestService } from '../services/my-notification.service';
import { TasksRestService } from '../services/tasks-rest.service';
import { SanctionsRescreenRestService } from '../services/sanctions-rescreen.service';
import { KycProspectsRestService } from '../services/kyc-prospects.service';
import { UwProspectsRestService } from '../services/uw-prospects.service';
import { RegistryLookupRestService } from '../services/registry-lookup.service';
import { OnboardingApplicationRestService } from '../services/onboarding-application.service';
import { OnboardingHistoryRestService } from '../services/onboarding-history.service';
import { KycWorkspaceRestService } from '../services/kyc-workspace.service';
import { FlowMonitorRestService } from '../services/flow-monitor.service';
import { KoConfigRestService } from '../services/ko-config.service';
import { BackendMocksRestService } from '../services/backend-mocks.service';
import { REGULATOR_CONFIG } from '../tokens/regulator-config.token';
import { RegulatorConfigRestService } from '../services/regulator-config.service';
import { RiskRatingRestService } from '../services/risk-rating.service';
import { LenderRiskProfilingRestService } from '../services/lender-risk-profiling.service';
import { SideTrackTriggersRestService } from '../services/side-track-triggers.service';
import { MasterAdminDashboardRestService } from '../services/master-admin-dashboard.service';
import { FlowControlRestService } from '../services/flow-control.service';
import { MasterAdminSettingsRestService } from '../services/master-admin-settings.service';
import { OfficerPreferencesRestService } from '../services/officer-preferences.service';
import { RatingScaleService } from '../services/rating-scale.service';
import { SlaThresholdService } from '../services/sla-threshold.service';
import { UwServicingRestService } from '../services/uw-servicing.service';
import { RejectionCodesRestService } from '../services/rejection-codes.service';
import { MasterAdminAuditRestService } from '../services/master-admin-audit.service';
import { OverrideLogRestService } from '../services/override-log.service';
import { MasterAdminUserMgmtRestService } from '../services/master-admin-user-mgmt.service';
import { LenderContractSigningRestService } from '../services/lender-contract-signing.service';
import { EdContractSigningRestService } from '../services/ed-contract-signing.service';
import { EdDiscountConfigRestService } from '../services/ed-discount-config.service';
import { EdProspectRestService } from '../services/ed-prospect.service';
import { ProspectConsentRestService } from '../services/prospect-consent.service';
import { PROSPECT_CONSENT } from '../tokens/prospect-consent.token';
import { ED_PRESCORING_RESULTS } from '../tokens/ed-prescoring-results.token';
import { EdPrescoringResultsRestService } from '../services/ed-prescoring-results.service';
import { ED_SMART_DISTRIBUTION } from '../tokens/ed-smart-distribution.token';
import { EdSmartDistributionRestService } from '../services/ed-smart-distribution.service';
import { ED_PORTFOLIO } from '../tokens/ed-portfolio.token';
import { EdPortfolioRestService } from '../services/ed-portfolio.service';
import { ED_SUPPLY_CHAIN_LIMIT } from '../tokens/ed-supply-chain-limit.token';
import { EdSupplyChainLimitRestService } from '../services/ed-supply-chain-limit.service';
import { ED_DASHBOARD } from '../tokens/ed-dashboard.token';
import { EdDashboardRestService } from '../services/ed-dashboard.service';
import { ED_SETTLEMENT } from '../tokens/ed-settlement.token';
import { EdSettlementRestService } from '../services/ed-settlement.service';
import { ED_CARD_OFFERS } from '../tokens/ed-card-offers.token';
import { EdCardOffersRestService } from '../services/ed-card-offers.service';
import { ED_TRANSACTIONS } from '../tokens/ed-transactions.token';
import { EdTransactionsRestService } from '../services/ed-transactions.service';
import { ED_REPORTS } from '../tokens/ed-reports.token';
import { EdReportsRestService } from '../services/ed-reports.service';
import { ED_PRODUCT_ASSIGNMENT } from '../tokens/ed-product-assignment.token';
import { EdProductAssignmentRestService } from '../services/ed-product-assignment.service';
import { ED_DATA_IMPORT } from '../tokens/ed-data-import.token';
import { EdDataImportRestService } from '../services/ed-data-import.service';
import { ED_PREFERENCES } from '../tokens/ed-preferences.token';
import { EdPreferencesRestService } from '../services/ed-preferences.service';
import { ED_VIBAN } from '../tokens/ed-viban.token';
import { EdVibanRestService } from '../services/ed-viban.service';
import { ED_KYP } from '../tokens/ed-kyp.token';
import { EdKypRestService } from '../services/ed-kyp.service';
import { ED_MESSAGES } from '../tokens/ed-messages.token';
import { EdMessagesRestService } from '../services/ed-messages.service';
import { SmeContractSigningRestService } from '../services/sme-contract-signing.service';
import { ApplicantModificationRestService } from '../services/applicant-modification.service';
import { SmeDashboardKpiRestService } from '../services/sme-dashboard-kpi.service';

/**
 * Production DI bindings — all tokens point at REST-backed implementations.
 *
 * Rule 07: The portal MUST call the real backend REST API for every feature.
 * Rule 10: No `Mock*` class files anywhere in `portal/src` — Playwright specs
 * intercept at the HTTP layer via `page.route()`; unit tests use inline stubs.
 *
 * Token summary:
 *
 * REGISTRY_LOOKUP → RegistryLookupRestService
 *   Calls GET /services/datacollector/api/company-info/{cui}.
 *   Authenticated (anonymous token via AnonymousAuthService for Stage-1 calls).
 *
 * ONBOARDING_APPLICATION → OnboardingApplicationRestService
 *   Calls /services/embedded/api/onboarding-application/{current,…}.
 *   Authenticated (signed-in SME bearer token via authInterceptor).
 *
 * KYC_WORKSPACE → KycWorkspaceRestService
 *   Surface that the unified TASKS token does NOT cover (appId-keyed):
 *   PSD2 connectivity/resolution, modification-loop display, completeness
 *   application fetch, and the legacy on-screen rendering helpers used by
 *   pages whose backend handler returns 501 on /api/tasks (Phase 5).
 *
 * FLOW_MONITOR → FlowMonitorRestService (EM-111 Flow Monitor)
 *   Calls /services/embedded/api/flow-monitor/onboarding/{tab}.
 *   Also calls /services/embedded/api/kyc-review/officers/active for the transfer modal.
 *   REST-only; no mock fallback. Playwright specs use `page.route()`.
 *   Authority: ROLE_KYC_OFFICER or ROLE_CUSTOMER_SUPPORT.
 *
 * KO_CONFIG → KoConfigRestService (EM-135 Master Admin KO Configuration)
 *   Calls /services/embedded/api/ko-rules.
 *   REST-only; no mock fallback. Playwright specs use `page.route()`.
 *   Authority: ROLE_MASTER_ADMIN.
 *
 * BACKEND_MOCKS → BackendMocksRestService (Master Admin — backend-mock provider configuration)
 *   Calls /services/embedded/api/master-admin/mock-providers.
 *   REST-only; no mock fallback. Playwright specs use `page.route()`.
 *   Authority: ROLE_MASTER_ADMIN.
 *
 * RISK_RATING → RiskRatingRestService (EM-155 ST-09 — Stage 7 scoring summary)
 *   Calls GET /services/embedded/api/risk-rating/{applicationId}.
 *   REST-only; no mock fallback. Playwright specs use `page.route()`.
 *   Authority: ROLE_KYC_OFFICER or ROLE_UNDERWRITER.
 *
 * LENDER_RISK_PROFILING → LenderRiskProfilingRestService (EM-158 ST-12 — Master Admin Lender Risk Profiling)
 *   Calls GET /services/embedded/api/risk-rating/lender-scoring-models/active,
 *         GET/PUT /services/embedded/api/lender-scoring-models/{id},
 *         GET/POST/PUT/DELETE /services/embedded/api/lender-model-translations.
 *   REST-only; no mock fallback. Playwright specs use `page.route()`.
 *   Authority: ROLE_MASTER_ADMIN.
 *
 * SIDE_TRACK_TRIGGERS → SideTrackTriggersRestService (EM-213 ST-7 — Master Admin Side-Track Trigger Audit Log)
 *   Calls GET /services/embedded/api/master-admin/side-track-triggers.
 *   REST-only; no mock fallback. Playwright specs use `page.route()`.
 *   Authority: ROLE_MASTER_ADMIN.
 *
 * SANCTIONS_RESCREEN → SanctionsRescreenRestService (EM-1349 — targeted re-screen)
 * KYC_PROSPECTS      → KycProspectsRestService (EM-1290 — T6.PR.03/04/05 prospect slice)
 * UW_PROSPECTS       → UwProspectsRestService (EM-1548 — UW.PR.01/UW.PR.02 prospect slice)
 *   Calls POST /services/embedded/api/onboarding-application/{id}/sanctions-screening/rescreen
 *   REST-only; no mock fallback. Playwright specs use `page.route()`.
 *   Authority: ROLE_KYC_OFFICER or ROLE_MASTER_ADMIN.
 *
 * TASKS → TasksRestService (tasks-refactoring — unified /api/tasks surface)
 *   Calls /services/embedded/api/tasks{,/{taskId},/{taskId}/dossier,
 *         /{taskId}/draft, /{taskId}/complete, /{taskId}/claim,
 *         /{taskId}/release, /{taskId}/transfer, /stats, /officers/active}.
 *   Consolidates the per-task-type REST services that previously sat on
 *   CIC_REVIEW, SANCTIONS_REVIEW, FINANCIAL_VERIFICATION, LICENSE_BLACKLIST_REVIEW,
 *   KO_REVIEW, UW_REVIEW, SENIOR_MGMT_SAR, STAGE7_SENIOR_MGMT_REVIEW.
 *   REST-only per Rule 10. Playwright specs intercept via `page.route('**​/api/tasks**', ...)`.
 *
 * MASTER_ADMIN_DASHBOARD → MasterAdminDashboardRestService (EM-235 — Dashboard KPI tiles)
 *   Calls GET /services/embedded/api/master-admin/dashboard.
 *   REST-only; no mock fallback. Playwright specs use `page.route()`.
 *   Authority: ROLE_MASTER_ADMIN.
 *
 * FLOW_CONTROL → FlowControlRestService (EM-238 — Flow A/B Control)
 *   Calls GET /services/embedded/api/flow-control,
 *         PUT /services/embedded/api/flow-control/{channel}/toggle,
 *         PUT /services/embedded/api/flow-control/reset-all.
 *   REST-only; no mock fallback. Playwright specs use `page.route()`.
 *   Authority: ROLE_MASTER_ADMIN.
 *
 * MASTER_ADMIN_SETTINGS → MasterAdminSettingsRestService (EM-241 — Settings preferences)
 *   Calls GET/PUT /services/embedded/api/master-admin/settings/preferences.
 *   REST-only; no mock fallback. Playwright specs use `page.route()`.
 *   Authority: ROLE_MASTER_ADMIN.
 *
 * MASTER_ADMIN_AUDIT → MasterAdminAuditRestService (EM-240 — Audit Log)
 *   Calls GET /services/embedded/api/master-admin/audit (paginated, X-Total-Count)
 *         GET /services/embedded/api/master-admin/audit/export (CSV Blob)
 *   REST-only; no mock fallback. Playwright specs use `page.route()`.
 *   Authority: ROLE_MASTER_ADMIN.
 *
 * LENDER_CONTRACT_SIGNING → LenderContractSigningRestService
 *   Calls GET  /services/embedded/api/business/lender/contract-signing/{applicationId}
 *         POST /services/embedded/api/business/lender/contract-signing/{applicationId}/upload
 *   REST-only; no mock fallback. Playwright specs use `page.route()`.
 *   Authority: ROLE_LENDER, ROLE_LENDER_RM, or ROLE_MASTER_ADMIN.
 *
 * SME_CONTRACT_SIGNING → SmeContractSigningRestService
 *   Calls GET  /services/embedded/api/business/sme/contract-signing/{applicationId}
 *         POST /services/embedded/api/business/sme/contract-signing/{applicationId}/upload
 *   REST-only; no mock fallback. Playwright specs use `page.route()`.
 *   Authority: ROLE_SME_BORROWER, ROLE_SME, or ROLE_MASTER_ADMIN.
 *
 * MASTER_ADMIN_USER_MGMT → MasterAdminUserMgmtRestService (EM-236 — User Management)
 *   Calls GET/POST /services/embedded/api/master-admin/users,
 *         PUT /services/embedded/api/master-admin/users/{id}/enabled,
 *         POST/DELETE /services/embedded/api/master-admin/users/{id}/roles{/{role}},
 *         POST /services/embedded/api/master-admin/users/{id}/reset-password,
 *         GET /services/embedded/api/master-admin/roles,
 *         GET /services/embedded/api/master-admin/groups,
 *         POST/DELETE /services/embedded/api/master-admin/groups/{groupId}/members/{userId},
 *         GET /services/embedded/api/master-admin/sessions,
 *         DELETE /services/embedded/api/master-admin/sessions/{id}.
 *   REST-only; no mock fallback. Playwright specs use `page.route()`.
 *   Authority: ROLE_MASTER_ADMIN.
 */
export const MOCK_DATA_PROVIDERS: Provider[] = [
  {
    provide:  REGISTRY_LOOKUP,
    useClass: RegistryLookupRestService,
  },
  {
    provide:  ONBOARDING_APPLICATION,
    useClass: OnboardingApplicationRestService,
  },
  {
    provide:  ONBOARDING_HISTORY,
    useClass: OnboardingHistoryRestService,
  },
  {
    provide:  KYC_WORKSPACE,
    useClass: KycWorkspaceRestService,
  },
  {
    provide:  FLOW_MONITOR,
    useClass: FlowMonitorRestService,
  },
  {
    provide:  KO_CONFIG,
    useClass: KoConfigRestService,
  },
  {
    provide:  BACKEND_MOCKS,
    useClass: BackendMocksRestService,
  },
  {
    provide:  CHAPTER4_CONFIG,
    useClass: Chapter4ConfigRestService,
  },
  {
    provide:  REGULATOR_CONFIG,
    useClass: RegulatorConfigRestService,
  },
  {
    provide:  RISK_RATING,
    useClass: RiskRatingRestService,
  },
  {
    provide:  LENDER_RISK_PROFILING,
    useClass: LenderRiskProfilingRestService,
  },
  {
    provide:  SIDE_TRACK_TRIGGERS,
    useClass: SideTrackTriggersRestService,
  },
  {
    provide:  SANCTIONS_RESCREEN,
    useClass: SanctionsRescreenRestService,
  },
  {
    provide:  KYC_PROSPECTS,
    useClass: KycProspectsRestService,
  },
  // UW_PROSPECTS → UwProspectsRestService (EM-1548 / epic EM-1447 Story 14 — UW.PR.01 / UW.PR.02).
  // Prospect-id-keyed like KYC_PROSPECTS; records consistency only, never a pre-approval verdict.
  {
    provide:  UW_PROSPECTS,
    useClass: UwProspectsRestService,
  },
  {
    provide:  TASKS,
    useClass: TasksRestService,
  },
  {
    provide:  MASTER_ADMIN_DASHBOARD,
    useClass: MasterAdminDashboardRestService,
  },
  {
    provide:  FLOW_CONTROL,
    useClass: FlowControlRestService,
  },
  {
    provide:  MASTER_ADMIN_SETTINGS,
    useClass: MasterAdminSettingsRestService,
  },
  // OFFICER_PREFERENCES → OfficerPreferencesRestService (EM-1295 / epic EM-1283; renamed
  // role-neutral by EM-1471 / epic EM-1447 Story 2 — the KYC officer AND the underwriter read their
  // own notification toggles over the SAME login-keyed row the master-admin page uses; the two write
  // disjoint field sets server-side, so neither page can reset the other's toggles).
  {
    provide:  OFFICER_PREFERENCES,
    useClass: OfficerPreferencesRestService,
  },
  // RATING_SCALE → RatingScaleService (EM-1466 / epic EM-1447 Story 2 — the ONE canonical 7-tier
  // scale, fetched once per session. No fallback tier table exists in the portal, deliberately.)
  // UW_SERVICING → UwServicingRestService (EM-1527 / epic EM-1447 Story 11 — the Stage 18–21
  // servicing read surface). LOAN-keyed, so it gets its own token rather than riding `TASKS`
  // (Rule 14). REST-only per Rule 10; Playwright intercepts via `page.route()`.
  //   GET  /v1/uw/servicing[?status=&product=&overdueOnly=]
  //   GET  /v1/uw/servicing/{loanReference}
  //   POST /v1/uw/servicing/{loanReference}/residual/release
  {
    provide:  UW_SERVICING,
    useClass: UwServicingRestService,
  },
  {
    provide:  RATING_SCALE,
    useClass: RatingScaleService,
  },
  // SLA_THRESHOLDS → SlaThresholdService (EM-1558 / epic EM-1447 Story 15 — the platform's SLA
  // colour ladder, fetched once per session and pushed into the ONE `deriveSlaClass` both officer
  // workspaces share. No fallback constants exist in the portal, deliberately.)
  //   GET /platform/sla-thresholds
  {
    provide:  SLA_THRESHOLDS,
    useClass: SlaThresholdService,
  },
  // REJECTION_CODES → RejectionCodesRestService (EM-1469 / epic EM-1447 Story 2 — the KO registry
  // projection. NOT cached: a Master-Admin threshold edit must show up on the next refresh.)
  {
    provide:  REJECTION_CODES,
    useClass: RejectionCodesRestService,
  },
  {
    provide:  MASTER_ADMIN_AUDIT,
    useClass: MasterAdminAuditRestService,
  },
  // OVERRIDE_LOG → OverrideLogRestService (EM-628 / S0-8 — SM Override / Compliance Log)
  {
    provide:  OVERRIDE_LOG,
    useClass: OverrideLogRestService,
  },
  {
    provide:  MASTER_ADMIN_USER_MGMT,
    useClass: MasterAdminUserMgmtRestService,
  },
  {
    provide:  LENDER_CONTRACT_SIGNING,
    useClass: LenderContractSigningRestService,
  },
  {
    provide:  ED_CONTRACT_SIGNING,
    useClass: EdContractSigningRestService,
  },
  {
    provide:  ED_DISCOUNT_CONFIG,
    useClass: EdDiscountConfigRestService,
  },
  {
    provide:  ED_PROSPECT,
    useClass: EdProspectRestService,
  },
  {
    // PROSPECT_CONSENT → ProspectConsentRestService (BRS §1A.0c, EM-773 — public consent-landing).
    provide:  PROSPECT_CONSENT,
    useClass: ProspectConsentRestService,
  },
  {
    // ED_PRESCORING_RESULTS → EdPrescoringResultsRestService (BRS §1A.0e, EM-808/809/810).
    provide:  ED_PRESCORING_RESULTS,
    useClass: EdPrescoringResultsRestService,
  },
  {
    // ED_SMART_DISTRIBUTION → EdSmartDistributionRestService (EM-822 — SDF facilities dashboard).
    provide:  ED_SMART_DISTRIBUTION,
    useClass: EdSmartDistributionRestService,
  },
  {
    // ED_PORTFOLIO → EdPortfolioRestService (PRD §3.2 / §2.3, EM-825/826).
    provide:  ED_PORTFOLIO,
    useClass: EdPortfolioRestService,
  },
  {
    // ED_SUPPLY_CHAIN_LIMIT → EdSupplyChainLimitRestService (PRD §1.7 / §3.17, EM-827).
    provide:  ED_SUPPLY_CHAIN_LIMIT,
    useClass: EdSupplyChainLimitRestService,
  },
  {
    // ED_DASHBOARD → EdDashboardRestService (PRD §3.1, EM-828).
    provide:  ED_DASHBOARD,
    useClass: EdDashboardRestService,
  },
  {
    // ED_SETTLEMENT → EdSettlementRestService (PRD §3.8, EM-834/835).
    provide:  ED_SETTLEMENT,
    useClass: EdSettlementRestService,
  },
  {
    // ED_CARD_OFFERS → EdCardOffersRestService (PRD §3.6, EM-836).
    provide:  ED_CARD_OFFERS,
    useClass: EdCardOffersRestService,
  },
  {
    // ED_TRANSACTIONS → EdTransactionsRestService (PRD §3.7, EM-837).
    provide:  ED_TRANSACTIONS,
    useClass: EdTransactionsRestService,
  },
  {
    // ED_REPORTS → EdReportsRestService (PRD §3.9, EM-838).
    provide:  ED_REPORTS,
    useClass: EdReportsRestService,
  },
  {
    // ED_PRODUCT_ASSIGNMENT → EdProductAssignmentRestService (PRD §3.10, EM-838).
    provide:  ED_PRODUCT_ASSIGNMENT,
    useClass: EdProductAssignmentRestService,
  },
  {
    // ED_DATA_IMPORT → EdDataImportRestService (PRD §3.11, EM-838).
    provide:  ED_DATA_IMPORT,
    useClass: EdDataImportRestService,
  },
  {
    // ED_PREFERENCES → EdPreferencesRestService (PRD §O.3 / BR-ED-020, EM-843/844 — KYP-Only Mode).
    provide:  ED_PREFERENCES,
    useClass: EdPreferencesRestService,
  },
  {
    // ED_VIBAN → EdVibanRestService (PRD §3.13, EM-845 — read-only V-IBAN & Payments).
    provide:  ED_VIBAN,
    useClass: EdVibanRestService,
  },
  {
    // ED_KYP → EdKypRestService (PRD §3.12, EM-847 — REST-only against the unbuilt /api/v1/kyp/*).
    provide:  ED_KYP,
    useClass: EdKypRestService,
  },
  {
    // ED_MESSAGES → EdMessagesRestService (PRD §3.15, EM-778 — two-way threaded messaging, MSG_RULES).
    provide:  ED_MESSAGES,
    useClass: EdMessagesRestService,
  },
  {
    provide:  SME_CONTRACT_SIGNING,
    useClass: SmeContractSigningRestService,
  },
  {
    // EM-856 — SME Stage-3 modification loop (corrections requested by KYC).
    provide:  APPLICANT_MODIFICATION,
    useClass: ApplicantModificationRestService,
  },
  {
    provide:  SME_SESSION,
    useClass: SmeSessionRestService,
  },
  // SME_PAYMENT_ACCOUNTS → SmePaymentAccountsRestService (EM-354 C1 — [COMMON] multi-currency
  // accounts + the session active-account signal every payments surface consumes; REST-only)
  {
    provide:  SME_PAYMENT_ACCOUNTS,
    useClass: SmePaymentAccountsRestService,
  },
  // SME_PAYMENTS → SmePaymentsRestService (EM-356 C3 — [COMMON] payment-submit + directory; the
  // single dispatch path the New Payment wizard mounts; REST-only, no Mock)
  {
    provide:  SME_PAYMENTS,
    useClass: SmePaymentsRestService,
  },
  // SME_PAYMENTS_DRAFTS → SmePaymentsDraftsRestService (EM-357 C4 — [COMMON] payment drafts CRUD +
  // cancel; consumed by the desktop hub Drafts tab + Upcoming-cancel and the wizard draft edit;
  // REST-only, no Mock)
  {
    provide:  SME_PAYMENTS_DRAFTS,
    useClass: SmePaymentsDraftsRestService,
  },
  // SME_TRANSACTIONS → SmeTransactionsRestService (EM-355 C2 — [COMMON] unified Past/Upcoming/Drafts
  // transaction feed; the shared paged state the dashboard tabs consume; REST-only, no Mock)
  {
    provide:  SME_TRANSACTIONS,
    useClass: SmeTransactionsRestService,
  },
  // SME_RECURRING → SmeRecurringRestService (EM-358 C5 — [COMMON] recurring rules / standing orders /
  // direct debits; the shared CRUD+pause/resume the W1 Recurring & DD table consumes; REST-only, no Mock)
  {
    provide:  SME_RECURRING,
    useClass: SmeRecurringRestService,
  },
  {
    provide:  SME_PERMISSIONS,
    useClass: SmePermissionsService,
  },
  {
    // EM-937 / F3+F6 — the authoritative role→permission definition, served over REST (FR-4.6).
    // Rule 07/10: REST-only, no Mock.
    provide:  ROLE_MATRIX,
    useClass: RoleMatrixService,
  },
  {
    provide:  SCA,
    useClass: ScaRestService,
  },
  // MY_AUDIT → MyAuditRestService (EM-309 — [COMMON] My Audit Log; shared by Story 7 dashboard + Story 9 screen)
  {
    provide:  MY_AUDIT,
    useClass: MyAuditRestService,
  },
  // MY_NOTIFICATIONS → MyNotificationRestService (EM-310 — [COMMON] My Notifications)
  {
    provide:  MY_NOTIFICATIONS,
    useClass: MyNotificationRestService,
  },
  // SME_DASHBOARD_KPI → SmeDashboardKpiRestService (EM-312 — Dashboard KPIs + compliance snapshot).
  // KPI / compliance endpoints belong to the Payments/Financing pillars (EPIC-2/EPIC-4) and do
  // NOT exist yet; the REST service returns structured-empty (`available:false`) until they land —
  // Rule 10 "no backend endpoint" carve-out, NOT a Mock (no fabricated numbers).
  {
    provide:  SME_DASHBOARD_KPI,
    useClass: SmeDashboardKpiRestService,
  },
  // INTEGRATION_FAILURES → IntegrationFailuresRestService (EM-353 — Master Admin Integration Failures)
  //   GET  /services/embedded/api/master-admin/integration-failures?status=&applicationId=&externalSystem=
  //   POST /services/embedded/api/master-admin/integration-failures/{id}/retry
  //   REST-only per Rule 10. Playwright specs intercept via `page.route('**​/integration-failures**', ...)`.
  {
    provide:  INTEGRATION_FAILURES,
    useClass: IntegrationFailuresRestService,
  },
  // CARD → CardRestService (EPIC-3 EM-413, K1 — [COMMON] "My Lendox Card": masked view + freeze/
  // unfreeze over /services/embedded/api/sme-cards/{cardId}. The shared card data-service every
  // EPIC-3 desktop/mobile screen consumes; K2–K8 append methods. REST-only, no Mock — the desktop
  // View sub-tab is WD1.)
  {
    provide:  CARD,
    useClass: CardRestService,
  },
  // SME Profile & Admin (EM-472) — 4 REST-only data services (Rule 07/10 — no Mock).
  // Backends shipped by Stories A–D on epic/EM-467: ProfileResource (/me/profile),
  // RepresentativeAdminResource (/parties/{id}/representatives), DocumentVaultResource
  // (/documents), ConsentCentreResource (/parties/{id}/consents).
  {
    provide:  SME_PROFILE,
    useClass: SmeProfileRestService,
  },
  {
    provide:  REPRESENTATIVES,
    useClass: RepresentativesRestService,
  },
  {
    provide:  SME_DOCUMENTS,
    useClass: SmeDocumentsRestService,
  },
  {
    provide:  SME_CONSENTS,
    useClass: SmeConsentsRestService,
  },
  // FINANCING_REQUEST → FinancingRequestRestService (EPIC-4 EM-500, Story 9 — EM-509).
  // The New-Request flow: POST /services/embedded/api/v1/applications (F-01 submit) + the
  // /me/dashboard/compliance eligibility snapshot. The single home (Rule 17) for the New
  // Request sub-tab + the 4-step wizard. REST-only, no Mock (Rule 07/10) — Playwright
  // specs intercept via page.route(). Story 10 appends the other 7 financing tokens.
  {
    provide:  FINANCING_REQUEST,
    useClass: FinancingRequestRestService,
  },
  // SPV → SpvInvoicesRestService (EM-1736, story EM-1670 — BRS §4.1.3 Primary Flow). The wizard's
  // Section-C e-Factura import: status/connect/invoices + draft-keyed selection. REST-only
  // (Rule 07/10); Playwright intercepts via page.route().
  {
    provide:  SPV,
    useClass: SpvInvoicesRestService,
  },
  // FINANCING SERVICING (EPIC-4 EM-500, Story 10 — EM-510). The 7 servicing tokens, all REST-only
  // (Rule 07/10 — no Mock; Playwright via page.route()), bound to the Stories 2–8 backends:
  //   AUCTIONS      → AuctionsRestService       (F-02/F-03 AuctionResource — /api/v1/auctions)
  //   DEALS         → DealsRestService          (F-04 DealSigningResource — /api/v1/deals, X-SCA-Token sign)
  //   LOANS         → LoansRestService          (F-05 LoanResource reads — /api/loans)
  //   REPAYMENTS    → RepaymentsRestService     (F-06 LoanResource repay/quote — /api/loans, X-SCA-Token)
  //   MODIFICATIONS → ModificationsRestService  (F-07 ModificationResource — /api/loans/{id}/modifications)
  //   INSURANCE     → InsuranceRestService      (F-08 InsuranceResource — /api/loans/{id}/insurance + /api/insurance/policies)
  //   COLLECTIONS   → CollectionsRestService    (F-09 CollectionResource — /api/collections)
  // The auctions/deals LIST methods are the Rule-10 "no backend endpoint yet" carve-out (structured
  // -empty, not Mock); all by-id read/action paths hit the live controllers.
  {
    provide:  AUCTIONS,
    useClass: AuctionsRestService,
  },
  {
    provide:  DEALS,
    useClass: DealsRestService,
  },
  {
    provide:  LOANS,
    useClass: LoansRestService,
  },
  {
    provide:  REPAYMENTS,
    useClass: RepaymentsRestService,
  },
  {
    provide:  MODIFICATIONS,
    useClass: ModificationsRestService,
  },
  {
    provide:  INSURANCE,
    useClass: InsuranceRestService,
  },
  {
    provide:  COLLECTIONS,
    useClass: CollectionsRestService,
  },
  // FINANCING_FLOW_MONITOR → FinancingFlowMonitorRestService (Flow Monitor: Loan/Factoring).
  //   GET /services/embedded/api/flow-monitor/loan/applications
  //   REST-only per Rule 10. Playwright specs intercept via `page.route()`.
  //   Authority: ROLE_MASTER_ADMIN.
  {
    provide:  FINANCING_FLOW_MONITOR,
    useClass: FinancingFlowMonitorRestService,
  },
  // LENDER_ACCOUNT → LenderAccountRestService (EM-256 §2.5.4 / §6.0.2 — lender Grace payment
  // account panel on the sme-account page). Calls:
  //   GET  /services/embedded/api/business/lender/account         → LenderAccountOverview
  //   POST /services/embedded/api/business/lender/account/cards   → LenderCardSummary
  // 404 `lenderAccountNotProvisioned` → friendly provisioning note (not an error banner).
  // REST-only per Rule 10. Playwright specs intercept via `page.route()`.
  {
    provide:  LENDER_ACCOUNT,
    useClass: LenderAccountRestService,
  },
  // BUSINESS_CARD → BusinessCardService (epic EM-915 §FR-5 — the party-type-agnostic card-request
  // surface behind the shared <app-card-request> component used by the Lender, SME and E-D account
  // pages). Calls:
  //   GET  /services/embedded/api/business/card/eligible-cardholders → EligibleCardholder[]
  //   POST /services/embedded/api/business/card/requests             → LenderCardSummary
  // REST-only per Rule 10. Playwright specs intercept via `page.route()`.
  {
    provide:  BUSINESS_CARD,
    useClass: BusinessCardService,
  },
  // GRACE_CONFIG → GraceConfigService — public Grace platform config endpoint.
  //   GET /services/embedded/api/grace-config → { defaultAccountCurrency, profile }
  // Used by Track-2 (default currency) and the profile-badge in staff shells.
  // REST-only (Rule 07/10). Anonymous token via AnonymousAuthService (endpoint is permitAll).
  // `useExisting` shares the same singleton as the `providedIn:'root'` instance.
  {
    provide:  GRACE_CONFIG,
    useExisting: GraceConfigService,
  },
  // GRACE_ACCOUNTS → GraceAccountsService — Master-Admin manual Grace-account linking.
  //   POST /services/embedded/api/master-admin/grace-accounts/map → MapGraceAccountResult
  // Links an existing Grace account (+ its cards) to a Lendox party; nothing is created in Grace.
  // REST-only per Rule 10. Playwright specs intercept via `page.route()`. Authority: ROLE_MASTER_ADMIN.
  {
    provide:  GRACE_ACCOUNTS,
    useClass: GraceAccountsService,
  },
  // ESCALATION_ANALYTICS → EscalationAnalyticsRestService (S-F / EM-662 — Master-Admin
  // escalation + performance analytics over OnboardingStageHistory). Calls:
  //   GET /services/embedded/api/escalation-analytics              → EscalationAnalytics
  //   GET /services/embedded/api/escalation-analytics/performance  → PerformanceAnalytics
  // REST-only per Rule 10. Playwright specs intercept via `page.route()`. Authority: ROLE_MASTER_ADMIN.
  {
    provide:  ESCALATION_ANALYTICS,
    useClass: EscalationAnalyticsRestService,
  },
  // SLA_ESCALATIONS → SlaEscalationsRestService (EM-1855 — the Escalation Queue's SLA source). Calls:
  //   GET /services/embedded/api/master-admin/sla-escalations → SlaEscalation[]
  // REST-only per Rule 10. Authority: ROLE_MASTER_ADMIN.
  {
    provide:  SLA_ESCALATIONS,
    useClass: SlaEscalationsRestService,
  },
  // ESCALATION_SCOPE → EscalationScopeRestService (EM-1890 — the Senior-Management task types the
  // Escalation Queue requests, served by the backend instead of a portal copy). Calls:
  //   GET /services/embedded/api/master-admin/escalation-scope → EscalationScope
  // REST-only per Rule 10. Authority: ROLE_MASTER_ADMIN.
  {
    provide:  ESCALATION_SCOPE,
    useClass: EscalationScopeRestService,
  },
  // TASK_REDISTRIBUTION → TaskRedistributionRestService (S-F / EM-660b + EM-661 — SM redistribution
  // of KYC tasks). Calls:
  //   POST /services/embedded/api/task-redistribution/{taskId}/reassign → WorkflowTask
  // (EM-1306: the officer list moved to the single directory GET /api/tasks/officers/active on
  //  the TASKS token; the duplicate /api/task-redistribution/officers endpoint was removed.)
  // ROLE_MASTER_ADMIN-gated; does NOT grant complete-rights (Rule 06 option b).
  // REST-only per Rule 10. Playwright specs intercept via `page.route()`.
  {
    provide:  TASK_REDISTRIBUTION,
    useClass: TaskRedistributionRestService,
  },
  // LENDER_IDENTITY → LenderIdentityRestService (EM-713 / P1 — session/auth unification).
  // The single server-side replacement for the static `ssoTitles` email→title maps. Calls:
  //   GET /services/embedded/api/v1/lender/identity → LenderIdentity { email, displayTitle, typology, channel }
  // REST-only per Rule 10. Playwright specs intercept via `page.route()`. Authority: ROLE_LENDER | ROLE_LENDER_RM.
  {
    provide:  LENDER_IDENTITY,
    useClass: LenderIdentityRestService,
  },
  // LENDER_CHANNELS_API → LenderChannelsRestService (EM-1613).
  // The one source of the lender's configuration-scope channels — General (marketplace) plus one
  // entry per REAL Enterprise Distributor. Calls:
  //   GET /services/embedded/api/v1/lender/channels → LenderChannelOption[]
  // Replaces the hard-coded `metro | selgros | arabesque` demo list the dashboard, Partner Space,
  // scope bars and portfolio filter each duplicated (Rule 17).
  // REST-only per Rule 10. Playwright specs intercept via `page.route()`. Authority: ROLE_LENDER | ROLE_LENDER_RM.
  {
    provide:  LENDER_CHANNELS_API,
    useClass: LenderChannelsRestService,
  },
  // LENDER_DASHBOARD → LenderDashboardRestService (EM-699 / F1 — EM-706 / PRD §5.1).
  // The SM/CRO dashboard is composed client-side (Rule 10 — no `GET /lender/dashboard`)
  // from the live endpoints: GET /v1/lender/portfolio + GET /v1/lender/repayments?range=7d
  // + GET /v1/exposure/limits/{channel}; Export via POST /v1/lender/reports/{type}.
  // REST-only per Rule 10. Playwright specs intercept via `page.route()`. Authority: ROLE_LENDER.
  {
    provide:  LENDER_DASHBOARD,
    useClass: LenderDashboardRestService,
  },
  // LENDER_RISK_RULES / LENDER_PRICING / LENDER_EXPOSURE → REST services (EM-699 / F2 — EM-707).
  // Per-channel SM/CRO config consuming the story-B3 backend (EM-702):
  //   GET/PUT /v1/risk-rules/{channel} + PUT /v1/risk-rules/{channel}/ko/{product}
  //   + POST /v1/risk-rules/{channel}/copy-from-general + PUT /v1/lpa/risk-rules/sync
  //   GET/PUT /v1/pricing/{channel} + POST /v1/pricing/{channel}/copy-from-general
  //   GET/PUT /v1/exposure/limits/{channel} + GET /v1/exposure/concentration
  // REST-only per Rule 10. Playwright specs intercept via `page.route()`. Authority: ROLE_LENDER.
  {
    provide:  LENDER_RISK_RULES,
    useClass: LenderRiskRulesRestService,
  },
  // EM-1675 / S7.4 — SM governance of lender KO adjustment requests. REST-only (Rules 07/10):
  //   GET/POST /api/master-admin/ko-adjustment-requests[...]  Authority: SENIOR_MANAGER | MASTER_ADMIN.
  {
    provide:  KO_ADJUSTMENTS_ADMIN,
    useClass: KoAdjustmentsAdminRestService,
  },
  {
    provide:  LENDER_PRICING,
    useClass: LenderPricingRestService,
  },
  {
    provide:  LENDER_EXPOSURE,
    useClass: LenderExposureRestService,
  },
  // EM-699 / F3 (EM-708) — Lender SM/CRO origination. REST-only (Rule 07/10):
  //   LENDER_OFFERS        → LenderOffersRestService        (B1 — /v1/lender/offers + /v1/auctions/{id}/ranking + counter-response)
  //   LENDER_PORTFOLIO     → LenderPortfolioRestService     (B6 — /v1/lender/portfolio, server-paginated)
  //   LENDER_OPPORTUNITIES → LenderOpportunitiesRestService (/v1/lender/opportunities — live; a failed call surfaces the backend message, never a fake empty list)
  // Authority: ROLE_LENDER (portfolio read also ROLE_LENDER_RM). Playwright via `page.route()`.
  {
    provide:  LENDER_OFFERS,
    useClass: LenderOffersRestService,
  },
  {
    provide:  LENDER_PORTFOLIO,
    useClass: LenderPortfolioRestService,
  },
  {
    provide:  LENDER_OPPORTUNITIES,
    useClass: LenderOpportunitiesRestService,
  },
  // LENDER_PROSPECTS → LenderProspectsRestService (EM-699 / F4 — EM-709 / PRD §5.9).
  // Partner Space: Tab 2 Pre-Approval Proposals hits the live B2 endpoints
  // (GET /v1/lender/prospects?partner=, POST /v1/lender/prospects/{cui}/verdict);
  // Tab 1 Invited SMEs is composed client-side from GET /v1/lender/portfolio (Rule 10 —
  // no dedicated endpoint). REST-only; Playwright intercepts via `page.route()`. Authority: ROLE_LENDER.
  {
    provide:  LENDER_PROSPECTS,
    useClass: LenderProspectsRestService,
  },
  // LENDER_BLACKLIST → LenderBlacklistRestService (EM-699 / F5 — EM-710 / PRD §5.10 / B1–B4).
  //   GET    /v1/lender/blacklist?q=&type=&status=  list (also ROLE_LENDER_RM)
  //   POST   /v1/lender/blacklist                   add (201, ROLE_LENDER)
  //   DELETE /v1/lender/blacklist/{id}              soft-remove (ROLE_LENDER)
  //   POST   /v1/lender/blacklist/{id}/restore      restore (ROLE_LENDER)
  // REST-only per Rule 10. Playwright specs intercept via `page.route()`. Authority: ROLE_LENDER.
  {
    provide:  LENDER_BLACKLIST,
    useClass: LenderBlacklistRestService,
  },
  // LENDER_PREAPPROVED_DEBTORS → LenderPreApprovedDebtorsRestService (EM-1752, story EM-1671 —
  // BRS §4.1.3 Section B debtor source category 2).
  //   GET    /v1/lender/preapproved-debtors?q=&product=&status=  list (also ROLE_LENDER_RM)
  //   GET    /v1/lender/preapproved-debtors/lookup?cui=          ONRC preview (ROLE_LENDER)
  //   POST   /v1/lender/preapproved-debtors                      add (201, ROLE_LENDER)
  //   PUT    /v1/lender/preapproved-debtors/{id}                 edit (ROLE_LENDER)
  //   DELETE /v1/lender/preapproved-debtors/{id}                 soft-remove (ROLE_LENDER)
  //   POST   /v1/lender/preapproved-debtors/{id}/restore         restore (ROLE_LENDER)
  // REST-only per Rule 10; lender-scoped server-side (Rule 22 shape). Playwright: page.route().
  {
    provide:  LENDER_PREAPPROVED_DEBTORS,
    useClass: LenderPreApprovedDebtorsRestService,
  },
  // DEBTOR_DIRECTORY → DebtorDirectoryRestService (EM-1750, story EM-1671 — BRS §4.1.3 Section B
  // "Debtor Sources (Three Categories)"). The SME financing wizard's Step-3 debtor picker.
  //   GET /v1/financing/debtors/search?q=&product=&limit=  platform E-D / lender pre-approved / registry
  //   GET /v1/financing/debtors/{cui}/resolve?product=     one debtor, authoritative (404 unknown)
  // REST-only per Rule 10. The backend owns the source union AND the ONRC projection — the portal
  // parses no registry data of its own (Rule 17); REGISTRY_LOOKUP stays for onboarding identity.
  {
    provide:  DEBTOR_DIRECTORY,
    useClass: DebtorDirectoryRestService,
  },
  // QUESTIONNAIRE → QuestionnaireRestService (EM-1772, story EM-1672 — BRS §4.1.4 "Product-Specific
  // Questionnaire" + the Auto-Population Principle). The financing wizard's questionnaire step and the
  // Stage-11 modification loop.
  //   GET /v1/financing/questionnaire/prefill?product=&debtorCui=…   the auto-population, pre-submission
  //   GET|PUT /v1/applications/{id}/questionnaire                    by-id read / rewrite
  // REST-only per Rule 10. The backend owns the source table, the read-only derivation and both
  // percentages — the portal renders them and decides none of them (Rule 17).
  {
    provide:  QUESTIONNAIRE,
    useClass: QuestionnaireRestService,
  },
  // EM-699 / F6 (EM-711) — Lender SM/CRO servicing UIs (PRD §5.6). REST-only per Rule 10;
  // Playwright specs intercept via `page.route()`. Authority: ROLE_LENDER (read also ROLE_LENDER_RM
  // for collections status, enforced server-side).
  //   LENDER_REPAYMENTS_API  → GET  /v1/lender/repayments?range=
  //   LENDER_COLLECTIONS_API → GET  /v1/lender/portfolio (overdue synthesis) + POST /v1/lender/collections/assign
  //                            + GET /v1/lender/collections/{accountId}
  //   LENDER_INSURANCE_API   → GET  /v1/lender/portfolio (uninsured synthesis) + POST /v1/lender/insurance/coverage
  //   LENDER_REPORTS_API     → POST /v1/lender/reports/{type}
  {
    provide:  LENDER_REPAYMENTS_API,
    useClass: LenderRepaymentsRestService,
  },
  {
    provide:  LENDER_COLLECTIONS_API,
    useClass: LenderCollectionsRestService,
  },
  {
    provide:  LENDER_INSURANCE_API,
    useClass: LenderInsuranceRestService,
  },
  {
    provide:  LENDER_REPORTS_API,
    useClass: LenderReportsRestService,
  },
  // EM-699 / F7 (EM-712) — Lender RM (Relationship Manager) portal. REST-only per Rule 10;
  // Playwright specs intercept via `page.route()`. Authority: ROLE_LENDER_RM (lender-scoped).
  //   RM_ONBOARDING       → POST /v1/rm/onboard (M1), POST /v1/rm/onboard/bulk (+/{id}/commit) (M2)
  //   RM_BLACKLIST_REPORT → POST /v1/blacklist/reports (B5 report-to-CRO)
  // The RM blacklist READ reuses LENDER_BLACKLIST.list() above (Rule 17 — no parallel read service).
  {
    provide:  RM_ONBOARDING,
    useClass: RmOnboardingRestService,
  },
  {
    provide:  RM_BLACKLIST_REPORT,
    useClass: RmBlacklistReportRestService,
  },
];
